import { usePlatformDashboardSelector } from 'platform-dashboard-ui/store';
// @ts-expect-error migrate upstream dependency
import { getLabel } from '../../../../../lib/dashboardFilters/propertySchema';
import { selectDataSourcesMetadataWithUniqueLabels } from 'platform-dashboard-ui/ducks/dataSourceMetadataSlice';
// @ts-expect-error migrate upstream dependency
import { getLabel as getDataSourceLabel } from '../../../../../lib/dashboardFilters/dataSourceMetadataSchema';
import { jsx as _jsx } from "react/jsx-runtime";
const DataSourcePropertyLabel = ({
  dataSource,
  property
}) => {
  const propertyDisplayName = getLabel(property);
  const dataSourceMetadata = usePlatformDashboardSelector(selectDataSourcesMetadataWithUniqueLabels([dataSource]));
  const dataSourceLabel = getDataSourceLabel(dataSourceMetadata[dataSource]);
  const dataTestId = `${dataSourceLabel} ${propertyDisplayName}`.replace(/ /g, '-').toLowerCase();
  return /*#__PURE__*/_jsx("span", {
    "data-test-id": `grouped-pinned-property-tooltip_${dataTestId}`,
    children: `${dataSourceLabel}: ${propertyDisplayName}`
  }, propertyDisplayName);
};
export default DataSourcePropertyLabel;